import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import { changeLocale } from '../../actions/i18n';

const mapStateToProps = ({ i18n }) => ({
  locale: i18n.locale,
  locales: i18n.locales,
});
const mapDispatchToProps = dispatch => bindActionCreators({
  change: changeLocale,
}, dispatch);

class Languages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
    };

    this.toggle = this.toggle.bind(this);
    this.change = this.change.bind(this);
  }

  toggle() {
    const { isOpened } = this.state;
    this.setState({ isOpened: !isOpened });
  }

  change(locale) {
    const { change } = this.props;
    change(locale);
    this.setState({ isOpened: false });
  }

  render() {
    const { isOpened } = this.state;
    const { locale, locales } = this.props;

    return (
      <Dropdown
        style={{ padding: "0 5px" }}
        nav
        isOpen={isOpened}
        toggle={this.toggle}
      >
        <DropdownToggle nav className="account_name">
          <p>
            <img
              src={(locales.find(({ id }) => id === locale) || { image: null }).image}
              className="flag"
            />
            {locale}
          </p>
        </DropdownToggle>
        <DropdownMenu right>
          {locales.map(({ id, name, image }) => (
            <DropdownItem key={id} onClick={() => this.change(id)}>
              <img src={image} alt={name} className="flag" />
              {name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

Languages.propTypes = {
  locale: PropTypes.string.isRequired,
  locales: PropTypes.arrayOf(PropTypes.object).isRequired,
  change: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Languages);



// WEBPACK FOOTER //
// ./src/components/_Header/_dropdownLang.js